import { ServiceTabsType } from '../types/admin-table.types'

const includeStatuses: Record<
  ServiceTabsType,
  Record<string, (string | number)[]>
> = {
  'все заявки': {
    statuses: [],
    ticketStatuses: [],
  },
  выполненные: {
    statuses: [6, 3, 16],
    ticketStatuses: [2, 4],
  },
  'заявки в работе': {
    statuses: [2, 4, 5, 11, 20, 24],
    ticketStatuses: [],
  },
  'заявки в отчётах': {
    statuses: [12, 13, 14, 15, 16],
    ticketStatuses: [],
  },
  'не выполненные': {
    statuses: [7, 10, 6, 30],
    ticketStatuses: [5],
  },
  'ожидающие заявки': {
    statuses: [1, 8],
    ticketStatuses: [],
  },
}

export const getValidStatusValues = (
  tab: ServiceTabsType,
  items: any,
  key: 'statuses' | 'ticketStatuses',
): any[] => {
  if (tab === 'все заявки') {
    return items
  } else {
    return items.filter((item: any) =>
      includeStatuses[tab][key]?.includes(item?.id),
    )
  }
}
